var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1746072390153,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1986,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M921.6 486.4c-6.4 0-16-3.2-22.4-6.4L512 176 121.6 480c-16 12.8-38.4 9.6-51.2-6.4-12.8-16-9.6-38.4 6.4-51.2L489.6 99.2c12.8-9.6 32-9.6 44.8 0l412.8 323.2c16 12.8 19.2 35.2 6.4 51.2-9.6 9.6-19.2 12.8-32 12.8z",
    fill: "#19AA8D",
    "p-id": 1987
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M220.8 953.6c-19.2 0-35.2-16-35.2-35.2V364.8c0-19.2 16-35.2 35.2-35.2s35.2 12.8 35.2 35.2v553.6c0 19.2-16 35.2-35.2 35.2zM800 953.6c-19.2 0-35.2-16-35.2-35.2V364.8c0-19.2 16-35.2 35.2-35.2 19.2 0 35.2 16 35.2 35.2v553.6c0 19.2-16 35.2-35.2 35.2z",
    fill: "#19AA8D",
    "p-id": 1988
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M924.8 956.8H102.4c-9.6 0-19.2-9.6-19.2-19.2s9.6-19.2 19.2-19.2h819.2c9.6 0 19.2 9.6 19.2 19.2s-6.4 19.2-16 19.2zM652.8 540.8h-291.2c-9.6 0-19.2-9.6-19.2-19.2s9.6-19.2 19.2-19.2h291.2c9.6 0 19.2 9.6 19.2 19.2s-9.6 19.2-19.2 19.2z",
    fill: "#19AA8D",
    "p-id": 1989
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M467.2 873.6h-76.8c-9.6 0-16-6.4-16-16v-76.8c0-9.6 6.4-16 16-16h76.8c9.6 0 16 6.4 16 16v76.8c0 9.6-6.4 16-16 16zM636.8 873.6h-76.8c-9.6 0-16-6.4-16-16v-76.8c0-9.6 6.4-16 16-16h76.8c9.6 0 16 6.4 16 16v76.8c0 9.6-6.4 16-16 16zM467.2 704h-76.8c-9.6 0-16-6.4-16-16v-76.8c0-9.6 6.4-16 16-16h76.8c9.6 0 16 6.4 16 16v76.8c0 6.4-6.4 16-16 16z",
    fill: "#F8AC59",
    "p-id": 1990
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.14fa10a30adf74dd53de60814daacc5b.svg";
export { ForwardRef as ReactComponent };